"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    standards: 'Standards',
    standardButton: {
        ariaLabel: 'Button to open standards information modal',
    },
};
